<template>
  <el-dialog title="加工明细" :visible.sync="visible" width="90%" :append-to-body="true">
    <el-form
        :inline="true"
        :model="queryForm"
        @keyup.enter.native="reload()"
        ref="queryForm"
        class="query-form"
    >
      <el-form-item prop="orderCode" :label="$t('orderCode')+'：'">
        <order-drop v-model="queryForm.orderCode" size="mini"></order-drop>
      </el-form-item>
      <el-form-item prop="customerId" label="客户">
        <customer v-model="queryForm.customerId" :disabled="disabledQuery.indexOf('customerId')>-1"></customer>
      </el-form-item>
      <el-form-item prop="batchCode" :label="$t('batchCode')+'：'">
        <el-input
            v-model="queryForm.batchCode"
            size="mini"
            clearable
            type="text"
        ></el-input>
      </el-form-item>
      <el-form-item prop="productCode" :label="$t('productCode')+'：'">
        <el-input
            v-model="queryForm.productCode"
            size="mini"
            clearable
            type="text"
            placeholder="品番号"
        ></el-input>
      </el-form-item>
      <el-form-item prop="skuCode" :label="$t('skuCode')+'：'">
        <el-input
            v-model="queryForm.skuCode"
            size="mini"
            clearable
            type="text"
        ></el-input>
      </el-form-item>
      <el-form-item prop="productName" :label="$t('productName')+'：'">
        <el-input
            v-model="queryForm.productName"
            size="mini"
            clearable
            type="text"
            placeholder="品名"
        ></el-input>
      </el-form-item>
      <el-form-item prop="nameZh" :label="$t('nameZh')+'：'">
        <el-input
            v-model="queryForm.nameZh"
            size="mini"
            clearable
            type="text"
            placeholder="中文品名"
        ></el-input>
      </el-form-item>

      <el-form-item prop="productColor" :label="$t('productColor')+'：'">
        <el-input
            v-model="queryForm.productColor"
            size="mini"
            clearable
            type="text"
            placeholder="颜色"
        ></el-input>
      </el-form-item>
      <el-form-item prop="productSize" :label="$t('productSize')+'：'">
        <el-input
            v-model="queryForm.productSize"
            size="mini"
            clearable
            type="text"
            placeholder="规格"
        ></el-input>
      </el-form-item>
      <el-form-item prop="sellerName" :label="$t('sellerName')+'：'">
        <el-input
            v-model="queryForm.sellerName"
            size="mini"
            clearable
            type="text"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="reload()" size="mini">{{ $t('query') }}</el-button>
        <el-button type="warning" @click="doCheck()" size="mini">确定选择</el-button>
      </el-form-item>
    </el-form>
    <SweetTable ref="table" :height="500" url="/erp/make/detail/page" :is-page="true" api-version="v2"
                :query-form="queryForm" :selection="true"
                :summaries-column="['count','totalPrice','receiveCount']"
    >
      <el-table-column :label="$t('orderCode')" prop="orderCode" header-align="center" align="center" fixed="left"
                       :show-overflow-tooltip="true" width="160px"></el-table-column>
      <el-table-column label="客户" prop="customerName" header-align="center" align="center" fixed="left"
                       :show-overflow-tooltip="true" width="160px"></el-table-column>
      <el-table-column :label="$t('batchCode')" prop="batchCode" header-align="center" align="center" fixed="left"
                       :show-overflow-tooltip="true" width="120px"></el-table-column>
      <el-table-column label="品番号" prop="product.code" header-align="center" align="center" fixed="left"
                       :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column label="SKU" prop="product.skuCode" header-align="center" align="center" fixed="left"
                       :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column label="品名" align="center" prop="product.name" :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column label="中文品名" align="center" prop="product.nameZh" :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
          label="颜色"
          prop="product.color"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
          label="规格"
          prop="product.size"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
          prop="sellerName"
          :label="$t('sellerName')"
          header-align="center"
          align="center"
          width="160" :format="$c.companyNameFormatter" :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="orderPrice"
          label="外销单价"
          header-align="center"
          align="center"
          width="100"
      ></el-table-column>

    </SweetTable>
  </el-dialog>
</template>

<script>
import SweetTable from '@/mixins/SweetTable'

export default {
  name: 'make-detail-dialog',
  mixins: [SweetTable],
  props: {
    disabledQuery: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      visible: false,
      queryForm: {
        makeId: null,
        exIds: [],
        sellerId: null,
        customerId: null,
        showCompletedOrder: false,
        orderCode: null,
        batchCode: null,
        productCode: null,
        productSkuCode: null,
        productName: null,
        productNameZh: null,
        productColor: null,
        productSize: null,
        sellerName: null,
        orderPrice: 'Y'
      },
    }
  },
  methods: {
    doCheck () {
      let rows = this.$refs.table.dataListSelections
      if (this.$c.isArrayEmpty(rows)) {
        return this.$message.error('请选择要发货的品番')
      }
      this.$emit('selected', rows)
      this.clearSelection()
      this.visible = false
    },
    init (exIds, customerId) {
      this.visible = true
      if (exIds instanceof Array) {
        this.queryForm.exIds = exIds.join(',')
      } else if (exIds instanceof String) {
        this.queryForm.exIds = exIds
      }
      this.queryForm.customerId = customerId
      this.$nextTick(() => {
        this.reload()
      })
    }
  }
}
</script>

<style scoped>

</style>
